var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { smoothCorner } from "apparatus/draw";
import { P, Pivot, R, Segments } from "apparatus/library/common";
import { Mounted } from "apparatus/library/physics/electric/mounted/utils";
import { Group, Path, PointText } from "paper";
import { staticImplements } from "types";
let MountedSwitch = class MountedSwitch {
    render(appearance) {
        const { base, jacks, snaps } = Mounted.renderPlate({ appearance, width: 80, height: 45 });
        // Draw the switch
        const halfWidth = 20;
        const thickness = 4;
        const height = 12;
        const elevation = 7;
        const baseRect = R(0, -height, halfWidth * 2, height + thickness, Pivot.TOP_CENTER);
        const around = new Path.Rectangle(baseRect.expand(7), 4.0)
            .withFill("#777777");
        const side = new Path.Rectangle(baseRect)
            .withFill("#666666");
        const top = new Path(Segments([[-halfWidth, 0]], [[0, 0]], [[halfWidth, -elevation]], [[halfWidth, -elevation - height]], [[0, -height]], [[-halfWidth, -height]])).close();
        const outline = top.clone();
        // Move the bottom side down to "thickness"
        outline.segments[0].point.y = thickness;
        outline.segments[1].point.y = thickness;
        outline.segments[2].point.y = thickness;
        outline.withStroke("default");
        smoothCorner(outline.segments[5], 2);
        smoothCorner(outline.segments[3], 2);
        smoothCorner(outline.segments[2], 2);
        smoothCorner(outline.segments[0], 2);
        const theswitch = new Group([around, side, top, outline]);
        if (appearance.position == "off") {
            top.withGradientFill("right", [
                ["#888888", 0.4],
                ["#aaaaaa", 0.6]
            ]);
        }
        else {
            top.withGradientFill("right", [
                ["#aaaaaa", 0.4],
                ["#888888", 0.6]
            ]);
            theswitch.scale(-1, 1);
        }
        theswitch.withPositionDelta(P(40, 17));
        const graphic = new Group([base, jacks, theswitch]);
        // Label
        if (appearance.showLabels) {
            let plusMinus = new PointText({
                point: P(38, 18),
                content: "O               I",
                fillColor: "white",
                fontFamily: "Rubik",
                fontSize: 14,
                justification: "center"
            });
            plusMinus.opacity = 0.4;
            graphic.addChild(plusMinus);
        }
        return {
            graphic,
            hitShape: graphic.rectHitShape(),
            snapping: [...snaps]
        };
    }
};
MountedSwitch.properties = {
    label: "Switch",
    defaultAppearance: Object.assign(Object.assign({}, Mounted.defaultAppearance), { position: "off", showLabels: false }),
    appearanceSpecs: [
        ...Mounted.appearanceSpecs,
        {
            spec: "toggle-buttons", key: "position", label: "State", size: "text",
            options: [
                { value: "off", label: "Off" },
                { value: "on", label: "On" },
            ]
        },
        {
            spec: "checkbox", key: "showLabels", label: "Labels", subLabel: "Show",
        },
    ],
};
MountedSwitch = __decorate([
    staticImplements()
], MountedSwitch);
export { MountedSwitch };
